// import React, { useState, useEffect } from 'react';
// import {
//   Table,
//   Card,
//   Button,
//   Input,
//   Space,
//   Tag,
//   Avatar,
//   Typography,
//   Modal,
//   Select,
//   message,
//   Popconfirm,
//   Drawer
// } from 'antd';
// import {
//   SearchOutlined,
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   UserOutlined,
//   EyeOutlined
// } from '@ant-design/icons';
// import userService from '../services/userService';
// import { useApiEnhanced } from '../hooks/useApiEnhanced';

// const { Title } = Typography;
// const { Option } = Select;

// // Sample user data
// const initialUsers = [
//   {
//     id: 1,
//     name: 'John Doe',
//     email: 'john.doe@example.com',
//     phone: '+1 234 567 8901',
//     role: 'Admin',
//     status: 'active',
//     avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=John',
//     joinDate: '2023-01-15',
//     department: 'IT'
//   },
//   {
//     id: 2,
//     name: 'Jane Smith',
//     email: 'jane.smith@example.com',
//     phone: '+1 234 567 8902',
//     role: 'User',
//     status: 'active',
//     avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Jane',
//     joinDate: '2023-02-20',
//     department: 'Marketing'
//   },
//   {
//     id: 3,
//     name: 'Bob Johnson',
//     email: 'bob.johnson@example.com',
//     phone: '+1 234 567 8903',
//     role: 'Manager',
//     status: 'inactive',
//     avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Bob',
//     joinDate: '2023-03-10',
//     department: 'Sales'
//   },
//   {
//     id: 4,
//     name: 'Alice Brown',
//     email: 'alice.brown@example.com',
//     phone: '+1 234 567 8904',
//     role: 'User',
//     status: 'active',
//     avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Alice',
//     joinDate: '2023-04-05',
//     department: 'HR'
//   },
//   {
//     id: 5,
//     name: 'Charlie Wilson',
//     email: 'charlie.wilson@example.com',
//     phone: '+1 234 567 8905',
//     role: 'User',
//     status: 'pending',
//     avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Charlie',
//     joinDate: '2023-05-12',
//     department: 'Finance'
//   }
// ];

// const UserPage = () => {
//   const {
//     data: users,
//     loading:usersLoading,
//     error:usersError,
//     execute: fetchUsers
//   } = useApiEnhanced(
//     () => userService.getUsers({ page: 1, limit: 100 }),
//     true // Load immediately
//   );

// //   const [users, setUsers] = useState(initialUsers);
//   const [loading, setLoading] = useState(false);
//   const [searchText, setSearchText] = useState('');
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [isViewDrawerVisible, setIsViewDrawerVisible] = useState(false);
//   const [editingUser, setEditingUser] = useState(null);
//   const [viewingUser, setViewingUser] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     role: 'User',
//     department: '',
//     status: 'active'
//   });

//   // Filter users based on search text
//   const filteredUsers = users?.data?.filter(user =>
//     user.name.toLowerCase().includes(searchText.toLowerCase()) ||
//     user.email.toLowerCase().includes(searchText.toLowerCase()) ||
//     user.role.toLowerCase().includes(searchText.toLowerCase()) ||
//     user.department.toLowerCase().includes(searchText.toLowerCase())
//   );

//   const handleAddUser = () => {
//     setEditingUser(null);
//     setFormData({
//       name: '',
//       email: '',
//       phone: '',
//       role: 'User',
//       department: '',
//       status: 'active'
//     });
//     setIsModalVisible(true);
//   };

//   const handleEditUser = (user) => {
//     setEditingUser(user);
//     setFormData(user);
//     setIsModalVisible(true);
//   };

//   const handleViewUser = (user) => {
//     setViewingUser(user);
//     setIsViewDrawerVisible(true);
//   };

//   const handleDeleteUser = (userId) => {
//     // setUsers(users.filter(user => user.id !== userId));
//     message.success('User deleted successfully');
//   };

//   const handleModalOk = () => {
//     // Simple validation
//     if (!formData.name || !formData.email || !formData.phone || !formData.role || !formData.department) {
//       message.error('Please fill in all required fields');
//       return;
//     }

//     if (editingUser) {
//       // Update existing user
//     //   setUsers(users.map(user =>
//     //     user.id === editingUser.id
//     //       ? { ...user, ...formData }
//     //       : user
//     //   ));
//       message.success('User updated successfully');
//     } else {
//       // Add new user
//       const newUser = {
//         id: Date.now(),
//         ...formData,
//         avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${formData.name}`,
//         joinDate: new Date().toISOString().split('T')[0]
//       };
//     //   setUsers([...users, newUser]);
//       message.success('User added successfully');
//     }
//     setIsModalVisible(false);
//     setFormData({
//       name: '',
//       email: '',
//       phone: '',
//       role: 'User',
//       department: '',
//       status: 'active'
//     });
//   };

//   const handleModalCancel = () => {
//     setIsModalVisible(false);
//     setFormData({
//       name: '',
//       email: '',
//       phone: '',
//       role: 'User',
//       department: '',
//       status: 'active'
//     });
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'active': return 'green';
//       case 'inactive': return 'red';
//       case 'pending': return 'orange';
//       default: return 'default';
//     }
//   };

//   const getRoleColor = (role) => {
//     switch (role) {
//       case 'Admin': return 'purple';
//       case 'Manager': return 'blue';
//       case 'Client': return 'cyan';
//       default: return 'default';
//     }
//   };

//   const columns = [
//     {
//       title: 'User',
//       dataIndex: 'name',
//       key: 'name',
//       render: (text, record) => (
//         <Space>
//           <Avatar src={record.avatar} icon={<UserOutlined />} />
//           <div>
//             <div style={{ fontWeight: 500 }}>{text}</div>
//             <div style={{ fontSize: '12px', color: '#666' }}>{record.email}</div>
//           </div>
//         </Space>
//       ),
//     },
//     {
//       title: 'Phone',
//       dataIndex: 'phone',
//       key: 'phone',
//     },
//     {
//       title: 'Role',
//       dataIndex: 'role',
//       key: 'role',
//       render: (role) => (
//         <Tag color={getRoleColor(role)}>{role}</Tag>
//       ),
//     },
//     // {
//     //   title: 'Department',
//     //   dataIndex: 'department',
//     //   key: 'department',
//     // },
//     // {
//     //   title: 'Status',
//     //   dataIndex: 'status',
//     //   key: 'status',
//     //   render: (status) => (
//     //     <Tag color={getStatusColor(status)}>
//     //       {status.charAt(0).toUpperCase() + status.slice(1)}
//     //     </Tag>
//     //   ),
//     // },
//     {
//       title: 'Join Date',
//       dataIndex: 'createdAt',
//       key: 'createdAt',
//     },
//     // {
//     //   title: 'Actions',
//     //   key: 'actions',
//     //   render: (_, record) => (
//     //     <Space>
//     //       <Button
//     //         type="text"
//     //         icon={<EyeOutlined />}
//     //         onClick={() => handleViewUser(record)}
//     //         title="View"
//     //       />
//     //       <Button
//     //         type="text"
//     //         icon={<EditOutlined />}
//     //         onClick={() => handleEditUser(record)}
//     //         title="Edit"
//     //       />
//     //       <Popconfirm
//     //         title="Are you sure you want to delete this user?"
//     //         onConfirm={() => handleDeleteUser(record.id)}
//     //         okText="Yes"
//     //         cancelText="No"
//     //       >
//     //         <Button
//     //           type="text"
//     //           danger
//     //           icon={<DeleteOutlined />}
//     //           title="Delete"
//     //         />
//     //       </Popconfirm>
//     //     </Space>
//     //   ),
//     // },
//   ];

//   return (
//     <div style={{ padding: '24px' }}>
//       <Card>
//         <div style={{ marginBottom: '24px' }}>
//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
//             <Title level={2} style={{ margin: 0 }}>User Management</Title>
//             <Button type="primary" icon={<PlusOutlined />} onClick={handleAddUser}>
//               Add User
//             </Button>
//           </div>

//           <Input
//             placeholder="Search users by name, email, role, or department"
//             prefix={<SearchOutlined />}
//             value={searchText}
//             onChange={(e) => setSearchText(e.target.value)}
//             style={{ width: '300px' }}
//           />
//         </div>

//         <Table
//           columns={columns}
//           dataSource={filteredUsers}
//           rowKey="id"
//           loading={loading}
//           pagination={{
//             total: filteredUsers?.length,
//             pageSize: 10,
//             showSizeChanger: true,
//             showQuickJumper: true,
//             showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users`,
//           }}
//           scroll={{ x: 800 }}
//         />
//       </Card>

//       {/* Add/Edit User Modal */}
//       <Modal
//         title={editingUser ? 'Edit User' : 'Add New User'}
//         open={isModalVisible}
//         onOk={handleModalOk}
//         onCancel={handleModalCancel}
//         width={600}
//       >
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//           <div>
//             <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Name *</label>
//             <Input
//               placeholder="Enter full name"
//               value={formData.name}
//               onChange={(e) => setFormData({...formData, name: e.target.value})}
//             />
//           </div>

//           <div>
//             <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Email *</label>
//             <Input
//               placeholder="Enter email address"
//               value={formData.email}
//               onChange={(e) => setFormData({...formData, email: e.target.value})}
//             />
//           </div>

//           <div>
//             <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Phone *</label>
//             <Input
//               placeholder="Enter phone number"
//               value={formData.phone}
//               onChange={(e) => setFormData({...formData, phone: e.target.value})}
//             />
//           </div>

//           <div style={{ display: 'flex', gap: '16px' }}>
//             <div style={{ flex: 1 }}>
//               <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Role *</label>
//               <Select
//                 placeholder="Select role"
//                 style={{ width: '100%' }}
//                 value={formData.role}
//                 onChange={(value) => setFormData({...formData, role: value})}
//               >
//                 <Option value="Admin">Admin</Option>
//                 <Option value="Manager">Manager</Option>
//                 <Option value="User">User</Option>
//               </Select>
//             </div>

//             <div style={{ flex: 1 }}>
//               <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Department *</label>
//               <Input
//                 placeholder="Enter department"
//                 value={formData.department}
//                 onChange={(e) => setFormData({...formData, department: e.target.value})}
//               />
//             </div>
//           </div>

//           <div>
//             <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Status *</label>
//             <Select
//               placeholder="Select status"
//               style={{ width: '100%' }}
//               value={formData.status}
//               onChange={(value) => setFormData({...formData, status: value})}
//             >
//               <Option value="active">Active</Option>
//               <Option value="inactive">Inactive</Option>
//               <Option value="pending">Pending</Option>
//             </Select>
//           </div>
//         </div>
//       </Modal>

//       {/* View User Drawer */}
//       <Drawer
//         title="User Details"
//         placement="right"
//         onClose={() => setIsViewDrawerVisible(false)}
//         open={isViewDrawerVisible}
//         width={400}
//       >
//         {viewingUser && (
//           <div>
//             <div style={{ textAlign: 'center', marginBottom: '24px' }}>
//               <Avatar size={80} src={viewingUser.avatar} icon={<UserOutlined />} />
//               <Title level={4} style={{ margin: '16px 0 8px 0' }}>{viewingUser.name}</Title>
//               <Tag color={getRoleColor(viewingUser.role)}>{viewingUser.role}</Tag>
//             </div>

//             <div style={{ marginBottom: '16px' }}>
//               <strong>Email:</strong><br />
//               {viewingUser.email}
//             </div>

//             <div style={{ marginBottom: '16px' }}>
//               <strong>Phone:</strong><br />
//               {viewingUser.phone}
//             </div>

//             <div style={{ marginBottom: '16px' }}>
//               <strong>Department:</strong><br />
//               {viewingUser.department}
//             </div>

//             {/* <div style={{ marginBottom: '16px' }}>
//               <strong>Status:</strong><br />
//               <Tag color={getStatusColor(viewingUser.status)}>
//                 {viewingUser.status.charAt(0).toUpperCase() + viewingUser.status.slice(1)}
//               </Tag>
//             </div> */}

//             <div style={{ marginBottom: '16px' }}>
//               <strong>Join Date:</strong><br />
//               {viewingUser.joinDate}
//             </div>
//           </div>
//         )}
//       </Drawer>
//     </div>
//   );
// };

// export default UserPage;

import React, { useState } from "react";
import {
  Table,
  Card,
  Button,
  Input,
  Space,
  Tag,
  Avatar,
  Typography,
  Modal,
  Select,
  message,
  Drawer,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  UserOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import userService from "../services/userService";
import { useApiEnhanced } from "../hooks/useApiEnhanced";

const { Title } = Typography;
const { Option } = Select;

const UserPage = () => {
  const {
    data: users,
    loading: usersLoading,
    error: usersError,
    execute: fetchUsers,
  } = useApiEnhanced(
    () => userService.getUsers({ page: 1, limit: 100 }),
    true // Load immediately
  );

  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isViewDrawerVisible, setIsViewDrawerVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [viewingUser, setViewingUser] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "User",
  });

  // Filter users based on search text
  const filteredUsers =
    users?.data?.filter(
      (user) =>
        user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        user.role?.toLowerCase().includes(searchText.toLowerCase())
    ) || [];

  const handleAddUser = () => {
    setEditingUser(null);
    setFormData({
      name: "",
      email: "",
      phone: "",
      role: "User",
    });
    setIsModalVisible(true);
  };

  const handleViewUser = (user) => {
    setViewingUser(user);
    setIsViewDrawerVisible(true);
  };

  const handleModalOk = async () => {
    // Simple validation
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.role
    ) {
      message.error("Please fill in all required fields");
      return;
    }

    try {
      if (editingUser) {
        // Update existing user
        await userService.updateUser(editingUser.id, formData);
        message.success("User updated successfully");
      } else {
        // Add new user
        await userService.createUser(formData);
        message.success("User added successfully");
      }

      // Refresh the users list
      fetchUsers();

      setIsModalVisible(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        role: "User",
      });
    } catch (error) {
      message.error("Operation failed. Please try again.");
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setFormData({
      name: "",
      email: "",
      phone: "",
      role: "User",
    });
  };

  const getRoleColor = (role) => {
    switch (role) {
      case "Admin":
        return "purple";
      case "Manager":
        return "blue";
      case "Client":
        return "cyan";
      default:
        return "default";
    }
  };

  const columns = [
    {
      title: "User",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          {/* <Avatar 
            src={record.avatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${record.name}`} 
            icon={<UserOutlined />} 
          /> */}
          <div>
            <div style={{ fontWeight: 500 }}>{text}</div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {record.email}
            </div>
          </div>
        </Space>
      ),
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "verified",
      dataIndex: "verified",
      key: "verified",
    },

    // {
    //   title: 'Role',
    //   dataIndex: 'role',
    //   key: 'role',
    //   render: (role) => (
    //     <Tag color={getRoleColor(role)}>{role}</Tag>
    //   ),
    // },
    {
      title: "Join Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => {
        if (!date) return "-";
        return new Date(date).toLocaleDateString();
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => handleViewUser(record)}
            title="View"
          />
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Card>
        <div style={{ marginBottom: "24px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <Title level={2} style={{ margin: 0 }}>
              User Management
            </Title>
          </div>

          <Input
            placeholder="Search users by name, email, or role"
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "300px" }}
          />
        </div>

        <Table
          columns={columns}
          dataSource={filteredUsers}
          rowKey="id"
          loading={usersLoading}
          pagination={{
            total: filteredUsers.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} users`,
          }}
          scroll={{ x: 800 }}
        />
      </Card>

      {/* Add/Edit User Modal */}
      <Modal
        title={editingUser ? "Edit User" : "Add New User"}
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        width={600}
        confirmLoading={usersLoading}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label
              style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}
            >
              Name *
            </label>
            <Input
              placeholder="Enter full name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </div>

          <div>
            <label
              style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}
            >
              Email *
            </label>
            <Input
              placeholder="Enter email address"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
          </div>

          <div>
            <label
              style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}
            >
              Phone *
            </label>
            <Input
              placeholder="Enter phone number"
              value={formData.phone}
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
            />
          </div>

          <div>
            <label
              style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}
            >
              Role *
            </label>
            <Select
              placeholder="Select role"
              style={{ width: "100%" }}
              value={formData.role}
              onChange={(value) => setFormData({ ...formData, role: value })}
            >
              <Option value="Admin">Admin</Option>
              <Option value="Manager">Manager</Option>
              <Option value="Client">Client</Option>
            </Select>
          </div>
        </div>
      </Modal>

      {/* View User Drawer */}
      <Drawer
        title="User Details"
        placement="right"
        onClose={() => setIsViewDrawerVisible(false)}
        open={isViewDrawerVisible}
        width={400}
      >
        {viewingUser && (
          <div>
            <div style={{ textAlign: "center", marginBottom: "24px" }}>
              <Avatar
                size={80}
                src={
                  viewingUser.avatar ||
                  `https://api.dicebear.com/7.x/avataaars/svg?seed=${viewingUser.name}`
                }
                icon={<UserOutlined />}
              />
              <Title level={4} style={{ margin: "16px 0 8px 0" }}>
                {viewingUser.name}
              </Title>
              <Tag color={getRoleColor(viewingUser.role)}>
                {viewingUser.role}
              </Tag>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <strong>Email:</strong>
              <br />
              {viewingUser.email}
            </div>

            <div style={{ marginBottom: "16px" }}>
              <strong>Phone:</strong>
              <br />
              {viewingUser.phone}
            </div>

            <div style={{ marginBottom: "16px" }}>
              <strong>Join Date:</strong>
              <br />
              {viewingUser.createdAt
                ? new Date(viewingUser.createdAt).toLocaleDateString()
                : "-"}
            </div>
          </div>
        )}
      </Drawer>
    </div>
  );
};

export default UserPage;
